import React from 'react';

import { LightningIcon } from 'shared/assets/lightning-icon';
import { useLoyalty } from 'src/hooks/use-loyalty';
import {
  ConsumerInfoContainer,
  InfoContainer,
  ThemedEmbeddedAccountIcon,
  InfoText,
  Points,
  ButtonContainer,
  BaseButton,
  EndSessionButton,
  Badge,
  LoginContainer,
  LoginButton,
  LoginText,
} from './consumer-info.styles';

type ConsumerInfoProps = {
  isUserLoggedIn: boolean;
  userFirstName?: string;
  startNewSession: () => void;
  orderSubTotal?: number;
  goToCart: () => void;
  kioskProModalLogin: () => Promise<void>;
  createPublicContextSessionLoading: boolean;
};

export function ConsumerInfo({
  isUserLoggedIn,
  userFirstName,
  startNewSession,
  orderSubTotal,
  goToCart,
  kioskProModalLogin,
  createPublicContextSessionLoading,
}: ConsumerInfoProps): JSX.Element {
  const { loyaltyPoints, isAlpineIQEnabled, isDutchiePOSLoyaltyEnabled, isSpringbigEnabled } = useLoyalty();
  const hasLoyaltyIntegration = isAlpineIQEnabled || isDutchiePOSLoyaltyEnabled || isSpringbigEnabled;

  return (
    <ConsumerInfoContainer $isUserLoggedIn={isUserLoggedIn}>
      {isUserLoggedIn ? (
        <InfoContainer>
          <ThemedEmbeddedAccountIcon />

          <InfoText>
            <span aria-hidden='true'>👋</span>
            &nbsp; Hi, {userFirstName}!{hasLoyaltyIntegration && <Points>{loyaltyPoints.toLocaleString()} pts</Points>}
          </InfoText>
        </InfoContainer>
      ) : (
        <LoginButton onClick={kioskProModalLogin} loading={createPublicContextSessionLoading}>
          <LoginContainer>
            <Badge>
              <LightningIcon /> Faster checkout
            </Badge>

            <LoginText>
              Login to reorder
              <br />
              your favorites
            </LoginText>
          </LoginContainer>
        </LoginButton>
      )}

      <ButtonContainer>
        <EndSessionButton onClick={startNewSession}>End Session</EndSessionButton>
        <BaseButton onClick={goToCart}>Cart ${(orderSubTotal ?? 0).toFixed(2)}</BaseButton>
      </ButtonContainer>
    </ConsumerInfoContainer>
  );
}
